<script lang="ts">
    // SSR needs source code to be present
    import Icon from "mdi-svelte/src/Index.svelte"

    export let path: string
    export let size: any = 1
</script>

<Icon path="{path}" size="{size}" />
